import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { AdminTabViews } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class AdministrationTabHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.AdministrationTab.SubTabSwitch, this.SubTabSwitch);
    }

    private SubTabSwitch(request: LocalEvent, store: AdministrationStore): void {
        var adminTabViews = request.Get<AdminTabViews>("value");
        store.adminTabModel = store.adminTabModel.set("CurrentView", adminTabViews);
    }
}

export { AdministrationTabHandler };
